<template>
  <div>
    <el-form ref="paramForm" :model="paramForm">
      <div class="form-box" v-for="(paramList,index) in paramForm.paramList" :key="'m'+index">
        <el-row>
          <el-col :span="6">
            <el-form-item
              :prop="'paramList.' + index + '.key'"
              :rules="[
                { required: true, message: 'key必填', trigger: 'blur' },
                { validator: checkParams, trigger: 'blur' }
              ]"
            >
             <template v-if="template==='none'">
               <el-input v-model="paramList.key" maxlength="45" :disabled="disabled"
                         placeholder="请输入key"></el-input>
             </template>
              <template v-else>
                <el-input v-model="paramList.name" maxlength="45" :disabled="true"></el-input>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="margin-left:10px">
            <el-form-item :prop="'paramList.' + index + '.value'"
                          :rules="{ required: true, message: 'value必填', trigger: 'blur' }">
              <el-input v-model="paramList.value" maxlength="1000" :disabled="disabled"
                        :placeholder="paramList.holder"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="template==='none'">
            <el-button style="margin-left:10px" @click="handleDelete(index)" v-if="!disabled && index !== 0">删除
            </el-button>
            <el-button style="margin-left:10px" @click="handleAdd"
                       v-if="!disabled && paramForm.paramList.length < 1000">添加
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  props: ['value', 'disabled', 'template'],
  data() {
    return {
      paramForm: {
        paramList: this.value
      }
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.paramForm.paramList = newValue
    }
  },
  methods: {
    handleDelete(index) {
      if (this.paramForm.paramList.length === 1) {
        this.paramForm.paramList[0].key = undefined
        this.paramForm.paramList[0].value = undefined
      } else {
        this.paramForm.paramList.splice(index, 1)
      }
    },
    handleAdd() {
      this.paramForm.paramList.push({
        key: undefined,
        value: undefined
      })
    },
    checkParams(rule, val, callback) {
      const paramKeyList = this.paramForm.paramList.map(item => item.key)
      const isUniq = paramKeyList.every((item, index) => {
        return paramKeyList.indexOf(item) === index
      })
      if (!isUniq) {
        return callback(new Error('key值不能重复'))
      }
      callback()
    }
  },
  created() {
  }
}
</script>
<style lang="stylus" scoped>
  .form-box
    margin-bottom 16px
</style>
